// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export default function promisifyMsSubtleCrypto(backend) {
    const usages = [
        'decrypt',
        'digest',
        'encrypt',
        'exportKey',
        'generateKey',
        'importKey',
        'sign',
        'verify',
    ];
    const decorateUsage = (fakeBackend, usage) => decorate(backend, fakeBackend, usage);
    return usages.reduce(decorateUsage, {});
}
function decorate(subtle, fakeBackend, name) {
    fakeBackend[name] = async (...args) => {
        return new Promise((resolve, reject) => {
            // @ts-ignore
            const operation = subtle[name](...args);
            operation.oncomplete = () => resolve(operation.result);
            operation.onerror = reject;
        });
    };
    return fakeBackend;
}
